var _defs, _g, _g2, _line, _g3, _line2, _g4, _line3, _g5, _line4, _g6, _line5, _g7, _line6, _g8, _line7, _g9, _line8, _g0, _line9, _g1, _line0, _g10, _line1, _g11, _line10, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _ellipse, _circle28, _circle29, _circle30, _circle31, _circle32, _ellipse2, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _ellipse3, _circle56, _circle57, _circle58, _circle59, _ellipse4, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _circle81, _circle82, _circle83, _circle84, _circle85, _circle86, _circle87, _circle88, _circle89, _circle90, _circle91, _circle92, _circle93, _circle94, _circle95, _circle96, _circle97, _ellipse5, _circle98, _circle99, _ellipse6, _circle100, _circle101, _circle102, _circle103, _circle104, _circle105, _circle106, _circle107, _circle108, _circle109, _circle110, _circle111, _circle112, _circle113, _circle114, _circle115, _circle116, _circle117, _circle118, _circle119, _circle120, _circle121, _circle122, _circle123, _circle124, _circle125, _circle126, _circle127, _circle128, _circle129, _circle130, _circle131, _circle132, _circle133, _circle134, _circle135, _circle136, _circle137, _circle138, _circle139, _circle140, _circle141, _circle142, _circle143, _circle144, _circle145, _circle146, _circle147, _circle148, _circle149, _circle150, _circle151, _circle152, _circle153, _circle154, _circle155, _circle156, _circle157, _circle158, _circle159, _circle160, _circle161, _circle162, _circle163, _circle164, _circle165, _circle166, _circle167, _circle168, _circle169, _circle170, _circle171, _circle172, _circle173, _circle174, _circle175, _circle176, _circle177, _circle178, _circle179, _circle180, _circle181, _circle182, _circle183, _circle184, _circle185, _circle186, _circle187, _circle188, _circle189, _circle190, _circle191, _circle192, _circle193, _circle194, _circle195, _circle196, _circle197, _circle198, _circle199, _circle200, _circle201, _circle202, _circle203, _ellipse7, _circle204, _circle205, _circle206, _circle207, _circle208, _circle209, _circle210, _circle211, _circle212, _circle213, _circle214, _circle215, _circle216, _circle217, _circle218, _circle219, _circle220, _circle221, _circle222, _circle223, _circle224, _circle225, _circle226, _circle227, _circle228, _circle229, _circle230, _circle231, _circle232, _circle233, _circle234, _circle235, _circle236, _circle237, _circle238, _circle239, _circle240, _circle241, _circle242, _circle243, _circle244, _circle245, _circle246, _circle247, _circle248, _circle249, _circle250, _circle251, _circle252, _circle253, _circle254, _circle255, _circle256, _circle257, _circle258, _circle259, _circle260, _circle261, _circle262, _circle263, _circle264, _circle265, _circle266, _circle267, _circle268, _circle269, _circle270, _circle271, _circle272, _circle273, _circle274, _ellipse8, _circle275, _circle276, _circle277, _circle278, _circle279, _circle280, _circle281, _circle282, _circle283, _circle284, _circle285, _circle286, _circle287, _circle288, _circle289, _circle290, _circle291, _circle292, _circle293, _circle294, _circle295, _circle296, _circle297, _circle298, _circle299, _circle300, _circle301, _circle302, _circle303, _circle304, _circle305, _circle306, _circle307, _circle308, _circle309, _circle310, _circle311, _circle312, _circle313, _circle314, _circle315, _circle316, _circle317, _circle318, _circle319, _circle320, _circle321, _circle322, _circle323, _circle324, _circle325, _circle326, _circle327, _circle328, _circle329, _circle330, _circle331, _circle332, _circle333, _circle334, _circle335, _circle336, _circle337, _circle338, _ellipse9, _circle339, _circle340, _circle341, _circle342, _circle343, _circle344, _circle345, _circle346, _circle347, _circle348, _circle349, _circle350, _circle351, _circle352, _circle353, _circle354, _circle355, _circle356, _circle357, _circle358, _circle359, _circle360, _circle361, _circle362, _circle363, _circle364, _circle365, _circle366, _circle367, _circle368, _circle369, _circle370, _circle371, _circle372, _circle373, _circle374, _circle375, _circle376, _circle377, _circle378, _circle379, _circle380, _circle381, _circle382, _circle383, _circle384, _circle385, _circle386, _circle387, _circle388, _circle389, _circle390, _circle391, _circle392, _circle393, _circle394, _circle395, _circle396, _circle397, _circle398, _circle399, _circle400, _circle401, _circle402, _circle403, _circle404, _circle405, _circle406, _circle407, _circle408, _circle409, _circle410, _circle411, _circle412, _circle413, _circle414, _circle415, _circle416, _circle417, _circle418, _circle419, _circle420, _circle421, _circle422, _circle423, _circle424, _circle425, _circle426, _ellipse0, _circle427, _circle428, _circle429, _circle430, _circle431, _circle432, _circle433, _circle434, _circle435, _circle436, _circle437, _circle438, _circle439, _circle440, _circle441, _circle442, _circle443, _circle444, _circle445, _circle446, _circle447, _circle448, _circle449, _circle450, _circle451, _circle452, _circle453, _circle454, _circle455, _circle456, _circle457, _circle458, _circle459, _circle460, _circle461, _circle462, _circle463, _circle464, _circle465, _circle466, _circle467, _circle468, _circle469, _circle470, _circle471, _circle472, _circle473, _circle474, _circle475, _circle476, _circle477, _circle478, _circle479, _circle480, _circle481, _circle482, _circle483, _circle484, _circle485, _circle486, _circle487, _circle488, _circle489, _circle490, _circle491, _circle492, _g12, _g13, _g14, _g15, _g16, _line11, _g17, _g18, _line12, _g19, _g20, _g21, _g22, _line13, _g23, _g24, _line14, _g25, _g26, _line15, _g27, _g28, _line16, _g29, _g30, _line17, _g31, _g32, _g33, _g34, _g35, _g36;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalAge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1774 304.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #ccc;\n      }\n\n      .st0, .st1, .st2, .st3 {\n        fill: none;\n      }\n\n      .st4, .st5, .st1, .st2 {\n        stroke: #000;\n      }\n\n      .st4, .st5, .st6 {\n        fill: #f7c548;\n      }\n\n      .st4, .st2, .st3 {\n        stroke-miterlimit: 10;\n      }\n\n      .st7, .st8, .st9, .st10, .st11, .st12 {\n        isolation: isolate;\n      }\n\n      .st7, .st9, .st10, .st11, .st12 {\n        fill: #212529;\n      }\n\n      .st7, .st10, .st11 {\n        font-size: 8px;\n      }\n\n      .st7, .st12 {\n        font-family: Roboto-Bold, Roboto;\n        font-weight: 700;\n      }\n\n      .st1 {\n        stroke-width: .8px;\n      }\n\n      .st9, .st11 {\n        font-family: Roboto-Light, Roboto;\n        font-weight: 300;\n      }\n\n      .st9, .st12 {\n        font-size: 6px;\n      }\n\n      .st2 {\n        stroke-width: .5px;\n      }\n\n      .st3 {\n        stroke: #212529;\n        stroke-dasharray: 0 2;\n        stroke-linecap: round;\n      }\n\n      .st10 {\n        font-family: Roboto-Regular, Roboto;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(0 18.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Minimum age of eligibility")))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "translate(0 27.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "25 years old")))))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 121.8,
    y1: 35.6,
    x2: 121.8,
    y2: 41.6
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(118.2 28.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "30"))))))), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 235,
    y1: 35.6,
    x2: 235,
    y2: 41.6
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(231.4 28.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "35"))))))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 348.2,
    y1: 35.6,
    x2: 348.2,
    y2: 41.6
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(344.5 28.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "40"))))))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 461.3,
    y1: 35.6,
    x2: 461.3,
    y2: 41.6
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(457.7 28.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "45"))))))), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 574.5,
    y1: 35.6,
    x2: 574.5,
    y2: 41.6
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(570.9 28.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "50"))))))), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 800.9,
    y1: 35.6,
    x2: 800.9,
    y2: 41.6
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(797.3 28.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "60"))))))), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 1027.2,
    y1: 35.6,
    x2: 1027.2,
    y2: 41.6
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(1023.6 28.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "70"))))))), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 1140.4,
    y1: 35.6,
    x2: 1140.4,
    y2: 41.6
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(1136.8 28.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "75"))))))), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 1253.6,
    y1: 35.6,
    x2: 1253.6,
    y2: 41.6
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(1250 28.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "80"))))))), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 1366.8,
    y1: 35.6,
    x2: 1366.8,
    y2: 41.6
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(1363.1 28.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "85"))))))), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 1479.9,
    y1: 35.6,
    x2: 1479.9,
    y2: 41.6
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(1476.3 28.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "90"))))))), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 20,
    y1: 180.6,
    x2: 1480,
    y2: 180.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 567,
    cy: 165.2,
    r: 6.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 756.2,
    cy: 202,
    r: 6.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 997.6,
    cy: 161.8,
    r: 6.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1076.6,
    cy: 202.5,
    r: 6.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 512,
    cy: 235.6,
    r: 6.5
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 917.6,
    cy: 134.2,
    r: 6.5
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 250.6,
    cy: 179.2,
    r: 6.5
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 809.4,
    cy: 159.3,
    r: 6.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 708.2,
    cy: 242.6,
    r: 6.5
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 853.6,
    cy: 167.8,
    r: 6.5
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1118.3,
    cy: 208.9,
    r: 6.5
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 741.7,
    cy: 199.1,
    r: 6.5
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 97,
    cy: 161.7,
    r: 6.5
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 745.8,
    cy: 256.2,
    r: 6.5
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 646,
    cy: 234,
    r: 6.5
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 553.4,
    cy: 242.7,
    r: 6.5
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 649.6,
    cy: 127.2,
    r: 6.5
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 587.3,
    cy: 222.6,
    r: 6.5
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 530.7,
    cy: 123.6,
    r: 6.5
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 727.8,
    cy: 126.8,
    r: 6.5
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 645.1,
    cy: 193.1,
    r: 6.5
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 833.7,
    cy: 151,
    r: 6.5
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 385.1,
    cy: 190,
    r: 6.5
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 497.7,
    cy: 231.1,
    r: 6.5
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 491.7,
    cy: 137.4,
    r: 6.5
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 887.7,
    cy: 136.1,
    r: 6.5
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 455,
    cy: 152.6,
    r: 6.5
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1277.8,
    cy: 180.6,
    r: 6.5
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 809.1,
    cy: 119,
    r: 6.5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 789.8,
    cy: 114,
    rx: 6.6,
    ry: 6.5
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 625.3,
    cy: 176.2,
    r: 6.5
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 804.4,
    cy: 185.2,
    r: 6.5
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 418.5,
    cy: 218.8,
    r: 6.5
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 765.5,
    cy: 149.8,
    r: 6.5
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 963.3,
    cy: 211.4,
    r: 6.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 655.2,
    cy: 115.4,
    rx: 6.6,
    ry: 6.5
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 634.9,
    cy: 124.6,
    r: 6.5
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1167.4,
    cy: 184.8,
    r: 6.5
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 411,
    cy: 190.7,
    r: 6.5
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1094.2,
    cy: 160.2,
    r: 6.5
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 853.3,
    cy: 123.9,
    r: 6.5
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 804.4,
    cy: 144.8,
    r: 6.5
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 702.4,
    cy: 139,
    r: 6.5
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1108.9,
    cy: 157.2,
    r: 6.5
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 610.8,
    cy: 173.4,
    r: 6.5
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 516.3,
    cy: 202.5,
    r: 6.5
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 663.8,
    cy: 169.9,
    r: 6.5
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1123.1,
    cy: 194.6,
    r: 6.5
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 982.7,
    cy: 162.7,
    r: 6.5
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 424.6,
    cy: 168.5,
    r: 6.5
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 717,
    cy: 167,
    r: 6.5
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 825.8,
    cy: 243.3,
    r: 6.5
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 730.8,
    cy: 257.3,
    r: 6.5
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 865.1,
    cy: 202.2,
    r: 6.5
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 620.1,
    cy: 121.8,
    r: 6.5
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 819.1,
    cy: 147.9,
    r: 6.5
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 561.4,
    cy: 150.5,
    r: 6.5
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 781.1,
    cy: 248.8,
    r: 6.5
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1066.7,
    cy: 191.2,
    r: 6.5
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 725.7,
    cy: 106.7,
    rx: 6.6,
    ry: 6.5
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 195.1,
    cy: 166.3,
    r: 6.5
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1195,
    cy: 188.4,
    r: 6.5
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 654.5,
    cy: 141.4,
    r: 6.5
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1003.2,
    cy: 218.7,
    r: 6.5
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 667.9,
    cy: 105.6,
    rx: 6.6,
    ry: 6.5
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 84.8,
    cy: 170.4,
    r: 6.5
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 879.3,
    cy: 236.9,
    r: 6.5
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 807.1,
    cy: 202.7,
    r: 6.5
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 546.5,
    cy: 148.6,
    r: 6.5
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 631.3,
    cy: 231.5,
    r: 6.5
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 437,
    cy: 143.3,
    r: 6.5
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 355.3,
    cy: 141.8,
    r: 6.5
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 389.4,
    cy: 210.2,
    r: 6.5
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 996.4,
    cy: 146.9,
    r: 6.5
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 969.9,
    cy: 197.9,
    r: 6.5
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 424.2,
    cy: 183.5,
    r: 6.5
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 644.3,
    cy: 153,
    r: 6.5
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 521.6,
    cy: 135.3,
    r: 6.5
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 357.6,
    cy: 156.7,
    r: 6.5
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 476.7,
    cy: 138.4,
    r: 6.5
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 844.8,
    cy: 243.9,
    r: 6.5
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 948.4,
    cy: 212.4,
    r: 6.5
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 862.2,
    cy: 242.4,
    r: 6.5
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 924.9,
    cy: 174.1,
    r: 6.5
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 582.1,
    cy: 208.2,
    r: 6.5
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 828.4,
    cy: 136.2,
    r: 6.5
  })), _circle81 || (_circle81 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 238.8,
    cy: 188.5,
    r: 6.5
  })), _circle82 || (_circle82 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 785.4,
    cy: 208.3,
    r: 6.5
  })), _circle83 || (_circle83 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 529.8,
    cy: 147.8,
    r: 6.5
  })), _circle84 || (_circle84 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 794.8,
    cy: 156.3,
    r: 6.5
  })), _circle85 || (_circle85 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 168.1,
    cy: 167,
    r: 6.5
  })), _circle86 || (_circle86 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 461.6,
    cy: 193.2,
    r: 6.5
  })), _circle87 || (_circle87 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 484.8,
    cy: 177.7,
    r: 6.5
  })), _circle88 || (_circle88 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 482.7,
    cy: 231.8,
    r: 6.5
  })), _circle89 || (_circle89 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1148.1,
    cy: 202.6,
    r: 6.5
  })), _circle90 || (_circle90 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 823.7,
    cy: 122,
    r: 6.5
  })), _circle91 || (_circle91 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 581.5,
    cy: 168,
    r: 6.5
  })), _circle92 || (_circle92 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 225.5,
    cy: 195.5,
    r: 6.5
  })), _circle93 || (_circle93 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 376.6,
    cy: 202.3,
    r: 6.5
  })), _circle94 || (_circle94 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 486.4,
    cy: 203.9,
    r: 6.5
  })), _circle95 || (_circle95 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 474.7,
    cy: 219.1,
    r: 6.5
  })), _circle96 || (_circle96 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 990.9,
    cy: 175.2,
    r: 6.5
  })), _circle97 || (_circle97 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 664.3,
    cy: 130.2,
    r: 6.5
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 683.4,
    cy: 108.9,
    rx: 6.6,
    ry: 6.5
  })), _circle98 || (_circle98 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 688,
    cy: 161.6,
    r: 6.5
  })), _circle99 || (_circle99 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 291.1,
    cy: 173,
    r: 6.5
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 760.5,
    cy: 108,
    rx: 6.6,
    ry: 6.5
  })), _circle100 || (_circle100 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 499.4,
    cy: 177,
    r: 6.5
  })), _circle101 || (_circle101 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 130.5,
    cy: 191.6,
    r: 6.5
  })), _circle102 || (_circle102 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 938.4,
    cy: 147,
    r: 6.5
  })), _circle103 || (_circle103 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 819.1,
    cy: 187.7,
    r: 6.5
  })), _circle104 || (_circle104 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 675.8,
    cy: 120.5,
    r: 6.5
  })), _circle105 || (_circle105 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 567.4,
    cy: 205.6,
    r: 6.5
  })), _circle106 || (_circle106 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1013.1,
    cy: 187.5,
    r: 6.5
  })), _circle107 || (_circle107 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 933.4,
    cy: 213.4,
    r: 6.5
  })), _circle108 || (_circle108 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 592.3,
    cy: 236.7,
    r: 6.5
  })), _circle109 || (_circle109 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 625,
    cy: 135.9,
    r: 6.5
  })), _circle110 || (_circle110 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 751.8,
    cy: 242.5,
    r: 6.5
  })), _circle111 || (_circle111 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 369.6,
    cy: 183.3,
    r: 6.5
  })), _circle112 || (_circle112 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 658.8,
    cy: 155.8,
    r: 6.5
  })), _circle113 || (_circle113 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 902.6,
    cy: 135.2,
    r: 6.5
  })), _circle114 || (_circle114 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 888.4,
    cy: 189.3,
    r: 6.5
  })), _circle115 || (_circle115 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1142.6,
    cy: 177.5,
    r: 6.5
  })), _circle116 || (_circle116 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 961.4,
    cy: 156.7,
    r: 6.5
  })), _circle117 || (_circle117 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 829.1,
    cy: 176.6,
    r: 6.5
  })), _circle118 || (_circle118 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 359.2,
    cy: 171.6,
    r: 6.5
  })), _circle119 || (_circle119 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1152.9,
    cy: 188.4,
    r: 6.5
  })), _circle120 || (_circle120 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 784.6,
    cy: 126.8,
    r: 6.5
  })), _circle121 || (_circle121 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 789.8,
    cy: 181.7,
    r: 6.5
  })), _circle122 || (_circle122 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 779.7,
    cy: 193.2,
    r: 6.5
  })), _circle123 || (_circle123 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1027,
    cy: 156.1,
    r: 6.5
  })), _circle124 || (_circle124 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 248.5,
    cy: 164.4,
    r: 6.5
  })), _circle125 || (_circle125 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 411.8,
    cy: 160.7,
    r: 6.5
  })), _circle126 || (_circle126 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1037.3,
    cy: 196.8,
    r: 6.5
  })), _circle127 || (_circle127 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 600.4,
    cy: 144.7,
    r: 6.5
  })), _circle128 || (_circle128 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 836,
    cy: 206.2,
    r: 6.5
  })), _circle129 || (_circle129 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 444.5,
    cy: 189.6,
    r: 6.5
  })), _circle130 || (_circle130 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 878.5,
    cy: 150.9,
    r: 6.5
  })), _circle131 || (_circle131 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 478.3,
    cy: 191.2,
    r: 6.5
  })), _circle132 || (_circle132 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 514.8,
    cy: 149,
    r: 6.5
  })), _circle133 || (_circle133 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 713.9,
    cy: 256.4,
    r: 6.5
  })), _circle134 || (_circle134 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 669.1,
    cy: 144.3,
    r: 6.5
  })), _circle135 || (_circle135 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 731.4,
    cy: 169.5,
    r: 6.5
  })), _circle136 || (_circle136 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 445.6,
    cy: 219.5,
    r: 6.5
  })), _circle137 || (_circle137 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 668.9,
    cy: 184.7,
    r: 6.5
  })), _circle138 || (_circle138 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1113.2,
    cy: 183.4,
    r: 6.5
  })), _circle139 || (_circle139 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 954.7,
    cy: 172.2,
    r: 6.5
  })), _circle140 || (_circle140 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 813.6,
    cy: 216.1,
    r: 6.5
  })), _circle141 || (_circle141 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 852.4,
    cy: 231,
    r: 6.5
  })), _circle142 || (_circle142 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 21,
    cy: 174.8,
    r: 6.5
  })), _circle143 || (_circle143 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 72.5,
    cy: 179.1,
    r: 6.5
  })), _circle144 || (_circle144 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 343.3,
    cy: 151.9,
    r: 6.5
  })), _circle145 || (_circle145 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 872.9,
    cy: 137.1,
    r: 6.5
  })), _circle146 || (_circle146 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 518.9,
    cy: 222.3,
    r: 6.5
  })), _circle147 || (_circle147 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1012.7,
    cy: 144.5,
    r: 6.5
  })), _circle148 || (_circle148 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 397.9,
    cy: 197.8,
    r: 6.5
  })), _circle149 || (_circle149 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 303.1,
    cy: 200.9,
    r: 6.5
  })), _circle150 || (_circle150 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1171.6,
    cy: 170,
    r: 6.5
  })), _circle151 || (_circle151 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 444.8,
    cy: 204.5,
    r: 6.5
  })), _circle152 || (_circle152 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 565.6,
    cy: 125.1,
    r: 6.5
  })), _circle153 || (_circle153 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1322.8,
    cy: 180.6,
    r: 6.5
  })), _circle154 || (_circle154 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 7.6,
    cy: 177.5,
    r: 6.5
  })), _circle155 || (_circle155 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1103.3,
    cy: 172.1,
    r: 6.5
  })), _circle156 || (_circle156 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 376,
    cy: 217.3,
    r: 6.5
  })), _circle157 || (_circle157 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 195.7,
    cy: 196.3,
    r: 6.5
  })), _circle158 || (_circle158 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 501.3,
    cy: 203.2,
    r: 6.5
  })), _circle159 || (_circle159 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 699.5,
    cy: 230.4,
    r: 6.5
  })), _circle160 || (_circle160 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 615,
    cy: 147.4,
    r: 6.5
  })), _circle161 || (_circle161 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 31.8,
    cy: 183.5,
    r: 6.5
  })), _circle162 || (_circle162 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 939.8,
    cy: 173.1,
    r: 6.5
  })), _circle163 || (_circle163 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 577.1,
    cy: 194.1,
    r: 6.5
  })), _circle164 || (_circle164 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 635.7,
    cy: 204.7,
    r: 6.5
  })), _circle165 || (_circle165 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 766.4,
    cy: 245.7,
    r: 6.5
  })), _circle166 || (_circle166 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 693.5,
    cy: 127,
    r: 6.5
  })), _circle167 || (_circle167 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 674,
    cy: 198.8,
    r: 6.5
  })), _circle168 || (_circle168 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1184.5,
    cy: 177.7,
    r: 6.5
  })), _circle169 || (_circle169 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 143,
    cy: 183.4,
    r: 6.5
  })), _circle170 || (_circle170 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 912,
    cy: 208.5,
    r: 6.5
  })), _circle171 || (_circle171 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 602,
    cy: 225.3,
    r: 6.5
  })), _circle172 || (_circle172 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 318.7,
    cy: 203.3,
    r: 6.5
  })), _circle173 || (_circle173 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 755.2,
    cy: 121.1,
    r: 6.5
  })), _circle174 || (_circle174 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 639.8,
    cy: 178.9,
    r: 6.5
  })), _circle175 || (_circle175 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1049.9,
    cy: 166.5,
    r: 6.5
  })), _circle176 || (_circle176 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 60.3,
    cy: 187.8,
    r: 6.5
  })), _circle177 || (_circle177 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 925,
    cy: 200.9,
    r: 6.5
  })), _circle178 || (_circle178 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 789.8,
    cy: 141.9,
    r: 6.5
  })), _circle179 || (_circle179 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1042.5,
    cy: 181.7,
    r: 6.5
  })), _circle180 || (_circle180 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1041.4,
    cy: 153.8,
    r: 6.5
  })), _circle181 || (_circle181 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 788.8,
    cy: 226.2,
    r: 6.5
  })), _circle182 || (_circle182 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 698.9,
    cy: 254.3,
    r: 6.5
  })), _circle183 || (_circle183 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 506.2,
    cy: 136.2,
    r: 6.5
  })), _circle184 || (_circle184 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 799.6,
    cy: 170.4,
    r: 6.5
  })), _circle185 || (_circle185 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 723,
    cy: 244.6,
    r: 6.5
  })), _circle186 || (_circle186 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 655.4,
    cy: 222.3,
    r: 6.5
  })), _circle187 || (_circle187 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 181,
    cy: 159.2,
    r: 6.5
  })), _circle188 || (_circle188 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 776.4,
    cy: 234.6,
    r: 6.5
  })), _circle189 || (_circle189 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 535.6,
    cy: 197.6,
    r: 6.5
  })), _circle190 || (_circle190 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 857.9,
    cy: 138.2,
    r: 6.5
  })), _circle191 || (_circle191 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 418.2,
    cy: 203.8,
    r: 6.5
  })), _circle192 || (_circle192 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 463.1,
    cy: 165.3,
    r: 6.5
  })), _circle193 || (_circle193 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 746.1,
    cy: 172.4,
    r: 6.5
  })), _circle194 || (_circle194 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 345,
    cy: 166.8,
    r: 6.5
  })), _circle195 || (_circle195 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 650.1,
    cy: 208.2,
    r: 6.5
  })), _circle196 || (_circle196 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 761.8,
    cy: 231.4,
    r: 6.5
  })), _circle197 || (_circle197 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 629.8,
    cy: 150.2,
    r: 6.5
  })), _circle198 || (_circle198 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 616.7,
    cy: 228,
    r: 6.5
  })), _circle199 || (_circle199 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1061.3,
    cy: 205.2,
    r: 6.5
  })), _circle200 || (_circle200 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 87.6,
    cy: 200.3,
    r: 6.5
  })), _circle201 || (_circle201 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 868.3,
    cy: 122.8,
    r: 6.5
  })), _circle202 || (_circle202 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 684.8,
    cy: 227.9,
    r: 6.5
  })), _circle203 || (_circle203 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 282.1,
    cy: 189.4,
    r: 6.5
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 712.8,
    cy: 114.5,
    rx: 6.6,
    ry: 6.5
  })), _circle204 || (_circle204 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 169.8,
    cy: 196.9,
    r: 6.5
  })), _circle205 || (_circle205 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 745.8,
    cy: 132.7,
    r: 6.5
  })), _circle206 || (_circle206 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 731.9,
    cy: 210.3,
    r: 6.5
  })), _circle207 || (_circle207 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 44,
    cy: 174.8,
    r: 6.5
  })), _circle208 || (_circle208 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1137.8,
    cy: 191.7,
    r: 6.5
  })), _circle209 || (_circle209 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 903.3,
    cy: 188.4,
    r: 6.5
  })), _circle210 || (_circle210 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 814.2,
    cy: 173.7,
    r: 6.5
  })), _circle211 || (_circle211 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 850.5,
    cy: 203.2,
    r: 6.5
  })), _circle212 || (_circle212 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 596.8,
    cy: 211,
    r: 6.5
  })), _circle213 || (_circle213 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 750.8,
    cy: 146.8,
    r: 6.5
  })), _circle214 || (_circle214 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 703,
    cy: 204.1,
    r: 6.5
  })), _circle215 || (_circle215 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 234.8,
    cy: 174,
    r: 6.5
  })), _circle216 || (_circle216 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 528.9,
    cy: 175.3,
    r: 6.5
  })), _circle217 || (_circle217 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 725.6,
    cy: 154.9,
    r: 6.5
  })), _circle218 || (_circle218 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 448.1,
    cy: 133.1,
    r: 6.5
  })), _circle219 || (_circle219 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 86.2,
    cy: 185.3,
    r: 6.5
  })), _circle220 || (_circle220 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 361.1,
    cy: 214,
    r: 6.5
  })), _circle221 || (_circle221 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 435.4,
    cy: 158.2,
    r: 6.5
  })), _circle222 || (_circle222 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 611.5,
    cy: 213.7,
    r: 6.5
  })), _circle223 || (_circle223 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 620,
    cy: 161.6,
    r: 6.5
  })), _circle224 || (_circle224 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 533.5,
    cy: 225.9,
    r: 6.5
  })), _circle225 || (_circle225 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 386.4,
    cy: 159.2,
    r: 6.5
  })), _circle226 || (_circle226 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 747.1,
    cy: 228.3,
    r: 6.5
  })), _circle227 || (_circle227 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 755.7,
    cy: 161,
    r: 6.5
  })), _circle228 || (_circle228 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 770,
    cy: 123.9,
    r: 6.5
  })), _circle229 || (_circle229 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 979,
    cy: 209.9,
    r: 6.5
  })), _circle230 || (_circle230 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 780.1,
    cy: 153.2,
    r: 6.5
  })), _circle231 || (_circle231 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 522.7,
    cy: 161.7,
    r: 6.5
  })), _circle232 || (_circle232 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 901.8,
    cy: 162.4,
    r: 6.5
  })), _circle233 || (_circle233 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1180.5,
    cy: 192.1,
    r: 6.5
  })), _circle234 || (_circle234 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1123.6,
    cy: 154.3,
    r: 6.5
  })), _circle235 || (_circle235 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1005.8,
    cy: 174.4,
    r: 6.5
  })), _circle236 || (_circle236 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 718.4,
    cy: 230.3,
    r: 6.5
  })), _circle237 || (_circle237 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 893.5,
    cy: 149.9,
    r: 6.5
  })), _circle238 || (_circle238 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 670.1,
    cy: 225.1,
    r: 6.5
  })), _circle239 || (_circle239 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 221.5,
    cy: 181,
    r: 6.5
  })), _circle240 || (_circle240 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1031.9,
    cy: 210.8,
    r: 6.5
  })), _circle241 || (_circle241 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 410.5,
    cy: 141.7,
    r: 6.5
  })), _circle242 || (_circle242 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 828.3,
    cy: 219,
    r: 6.5
  })), _circle243 || (_circle243 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 455.1,
    cy: 179.2,
    r: 6.5
  })), _circle244 || (_circle244 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1255.4,
    cy: 180.6,
    r: 6.5
  })), _circle245 || (_circle245 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 362,
    cy: 199.1,
    r: 6.5
  })), _circle246 || (_circle246 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 690.2,
    cy: 242.1,
    r: 6.5
  })), _circle247 || (_circle247 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 660.7,
    cy: 236.8,
    r: 6.5
  })), _circle248 || (_circle248 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 649.3,
    cy: 167.2,
    r: 6.5
  })), _circle249 || (_circle249 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1118,
    cy: 169.2,
    r: 6.5
  })), _circle250 || (_circle250 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 736,
    cy: 144,
    r: 6.5
  })), _circle251 || (_circle251 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 489.7,
    cy: 218.5,
    r: 6.5
  })), _circle252 || (_circle252 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 461.8,
    cy: 139.2,
    r: 6.5
  })), _circle253 || (_circle253 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 798.7,
    cy: 215,
    r: 6.5
  })), _circle254 || (_circle254 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 981.4,
    cy: 147.8,
    r: 6.5
  })), _circle255 || (_circle255 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 899.3,
    cy: 217.5,
    r: 6.5
  })), _circle256 || (_circle256 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 208.2,
    cy: 173.5,
    r: 6.5
  })), _circle257 || (_circle257 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 678.2,
    cy: 173.1,
    r: 6.5
  })), _circle258 || (_circle258 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 760.9,
    cy: 216.5,
    r: 6.5
  })), _circle259 || (_circle259 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 794.2,
    cy: 196.1,
    r: 6.5
  })), _circle260 || (_circle260 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 595.5,
    cy: 130.5,
    r: 6.5
  })), _circle261 || (_circle261 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 182.9,
    cy: 204.1,
    r: 6.5
  })), _circle262 || (_circle262 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 680.6,
    cy: 134.7,
    r: 6.5
  })), _circle263 || (_circle263 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 698,
    cy: 190,
    r: 6.5
  })), _circle264 || (_circle264 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 940,
    cy: 199.9,
    r: 6.5
  })), _circle265 || (_circle265 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1157.2,
    cy: 173.9,
    r: 6.5
  })), _circle266 || (_circle266 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 601.6,
    cy: 185.2,
    r: 6.5
  })), _circle267 || (_circle267 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 321,
    cy: 176.6,
    r: 6.5
  })), _circle268 || (_circle268 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 154.8,
    cy: 160.2,
    r: 6.5
  })), _circle269 || (_circle269 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 732.5,
    cy: 225.3,
    r: 6.5
  })), _circle270 || (_circle270 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 572.7,
    cy: 219.7,
    r: 6.5
  })), _circle271 || (_circle271 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 58.9,
    cy: 172.8,
    r: 6.5
  })), _circle272 || (_circle272 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 702.7,
    cy: 163.6,
    r: 6.5
  })), _circle273 || (_circle273 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 727.3,
    cy: 195.3,
    r: 6.5
  })), _circle274 || (_circle274 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 116.3,
    cy: 169.8,
    r: 6.5
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 744.3,
    cy: 105.6,
    rx: 6.6,
    ry: 6.5
  })), _circle275 || (_circle275 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1073.9,
    cy: 178,
    r: 6.5
  })), _circle276 || (_circle276 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 537.5,
    cy: 160.6,
    r: 6.5
  })), _circle277 || (_circle277 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 128.8,
    cy: 161.6,
    r: 6.5
  })), _circle278 || (_circle278 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 590.7,
    cy: 156.1,
    r: 6.5
  })), _circle279 || (_circle279 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 234.5,
    cy: 159,
    r: 6.5
  })), _circle280 || (_circle280 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 17,
    cy: 189.7,
    r: 6.5
  })), _circle281 || (_circle281 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 843.9,
    cy: 179.2,
    r: 6.5
  })), _circle282 || (_circle282 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 933.1,
    cy: 186.6,
    r: 6.5
  })), _circle283 || (_circle283 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1093.7,
    cy: 200.6,
    r: 6.5
  })), _circle284 || (_circle284 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 73.9,
    cy: 194,
    r: 6.5
  })), _circle285 || (_circle285 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 962.9,
    cy: 184.7,
    r: 6.5
  })), _circle286 || (_circle286 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 977.6,
    cy: 182,
    r: 6.5
  })), _circle287 || (_circle287 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 818.4,
    cy: 230.3,
    r: 6.5
  })), _circle288 || (_circle288 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 326.6,
    cy: 190.5,
    r: 6.5
  })), _circle289 || (_circle289 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 296.8,
    cy: 186.9,
    r: 6.5
  })), _circle290 || (_circle290 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 775.5,
    cy: 219.5,
    r: 6.5
  })), _circle291 || (_circle291 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 659.4,
    cy: 196.4,
    r: 6.5
  })), _circle292 || (_circle292 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 563,
    cy: 231.3,
    r: 6.5
  })), _circle293 || (_circle293 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1132.7,
    cy: 166.2,
    r: 6.5
  })), _circle294 || (_circle294 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1108.4,
    cy: 197.6,
    r: 6.5
  })), _circle295 || (_circle295 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1098.5,
    cy: 186.4,
    r: 6.5
  })), _circle296 || (_circle296 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 675.4,
    cy: 239.6,
    r: 6.5
  })), _circle297 || (_circle297 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 932.5,
    cy: 133.2,
    r: 6.5
  })), _circle298 || (_circle298 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 908.4,
    cy: 149,
    r: 6.5
  })), _circle299 || (_circle299 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1027.9,
    cy: 185.2,
    r: 6.5
  })), _circle300 || (_circle300 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 692.8,
    cy: 175.7,
    r: 6.5
  })), _circle301 || (_circle301 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1057.4,
    cy: 179.5,
    r: 6.5
  })), _circle302 || (_circle302 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 270.2,
    cy: 198.7,
    r: 6.5
  })), _circle303 || (_circle303 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 156.4,
    cy: 190.2,
    r: 6.5
  })), _circle304 || (_circle304 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 916.8,
    cy: 161.5,
    r: 6.5
  })), _circle305 || (_circle305 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 863.3,
    cy: 152.1,
    r: 6.5
  })), _circle306 || (_circle306 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1057.1,
    cy: 153.3,
    r: 6.5
  })), _circle307 || (_circle307 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 605.4,
    cy: 158.8,
    r: 6.5
  })), _circle308 || (_circle308 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 712.5,
    cy: 192.6,
    r: 6.5
  })), _circle309 || (_circle309 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 885.4,
    cy: 223.2,
    r: 6.5
  })), _circle310 || (_circle310 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 437.4,
    cy: 176.4,
    r: 6.5
  })), _circle311 || (_circle311 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 523.2,
    cy: 189.2,
    r: 6.5
  })), _circle312 || (_circle312 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 736.5,
    cy: 183.6,
    r: 6.5
  })), _circle313 || (_circle313 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 799.2,
    cy: 130.2,
    r: 6.5
  })), _circle314 || (_circle314 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 385.5,
    cy: 175,
    r: 6.5
  })), _circle315 || (_circle315 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 507.5,
    cy: 162.4,
    r: 6.5
  })), _circle316 || (_circle316 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 673.6,
    cy: 158.6,
    r: 6.5
  })), _circle317 || (_circle317 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 276.3,
    cy: 175.6,
    r: 6.5
  })), _circle318 || (_circle318 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 821.7,
    cy: 202.3,
    r: 6.5
  })), _circle319 || (_circle319 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 923.4,
    cy: 148,
    r: 6.5
  })), _circle320 || (_circle320 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 543.3,
    cy: 174.3,
    r: 6.5
  })), _circle321 || (_circle321 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1012.4,
    cy: 159.5,
    r: 6.5
  })), _circle322 || (_circle322 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 775.3,
    cy: 178.9,
    r: 6.5
  })), _circle323 || (_circle323 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 354.9,
    cy: 185.9,
    r: 6.5
  })), _circle324 || (_circle324 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 634.6,
    cy: 164.4,
    r: 6.5
  })), _circle325 || (_circle325 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 405,
    cy: 211,
    r: 6.5
  })), _circle326 || (_circle326 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 458.1,
    cy: 211.4,
    r: 6.5
  })), _circle327 || (_circle327 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 838.4,
    cy: 125,
    r: 6.5
  })), _circle328 || (_circle328 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 750.6,
    cy: 187.2,
    r: 6.5
  })), _circle329 || (_circle329 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 894.3,
    cy: 235.2,
    r: 6.5
  })), _circle330 || (_circle330 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 664.9,
    cy: 210.6,
    r: 6.5
  })), _circle331 || (_circle331 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 955,
    cy: 198.9,
    r: 6.5
  })), _circle332 || (_circle332 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 998.2,
    cy: 188.6,
    r: 6.5
  })), _circle333 || (_circle333 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 694.2,
    cy: 216.3,
    r: 6.5
  })), _circle334 || (_circle334 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 848.4,
    cy: 153.6,
    r: 6.5
  })), _circle335 || (_circle335 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 918.2,
    cy: 187.6,
    r: 6.5
  })), _circle336 || (_circle336 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 541,
    cy: 134.7,
    r: 6.5
  })), _circle337 || (_circle337 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 493.2,
    cy: 190.6,
    r: 6.5
  })), _circle338 || (_circle338 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1022.5,
    cy: 199.1,
    r: 6.5
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 775.1,
    cy: 110.4,
    rx: 6.6,
    ry: 6.5
  })), _circle339 || (_circle339 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1227.1,
    cy: 185.3,
    r: 6.5
  })), _circle340 || (_circle340 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 683.4,
    cy: 187.3,
    r: 6.5
  })), _circle341 || (_circle341 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 182.2,
    cy: 174.1,
    r: 6.5
  })), _circle342 || (_circle342 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1345.2,
    cy: 180.6,
    r: 6.5
  })), _circle343 || (_circle343 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 722.1,
    cy: 181.1,
    r: 6.5
  })), _circle344 || (_circle344 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1083.8,
    cy: 189.3,
    r: 6.5
  })), _circle345 || (_circle345 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 711.1,
    cy: 151.2,
    r: 6.5
  })), _circle346 || (_circle346 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 398.3,
    cy: 182.8,
    r: 6.5
  })), _circle347 || (_circle347 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 679.5,
    cy: 213.5,
    r: 6.5
  })), _circle348 || (_circle348 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 399.6,
    cy: 152,
    r: 6.5
  })), _circle349 || (_circle349 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 898.3,
    cy: 202.5,
    r: 6.5
  })), _circle350 || (_circle350 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 953.1,
    cy: 144.2,
    r: 6.5
  })), _circle351 || (_circle351 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 571,
    cy: 139,
    r: 6.5
  })), _circle352 || (_circle352 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 948,
    cy: 185.6,
    r: 6.5
  })), _circle353 || (_circle353 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 398.7,
    cy: 167.8,
    r: 6.5
  })), _circle354 || (_circle354 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 371.6,
    cy: 151.4,
    r: 6.5
  })), _circle355 || (_circle355 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 689.5,
    cy: 146.7,
    r: 6.5
  })), _circle356 || (_circle356 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 470,
    cy: 178.7,
    r: 6.5
  })), _circle357 || (_circle357 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 867.1,
    cy: 228.2,
    r: 6.5
  })), _circle358 || (_circle358 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 596.2,
    cy: 170.6,
    r: 6.5
  })), _circle359 || (_circle359 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 274.1,
    cy: 160.7,
    r: 6.5
  })), _circle360 || (_circle360 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1020.6,
    cy: 172.1,
    r: 6.5
  })), _circle361 || (_circle361 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 508.2,
    cy: 189.9,
    r: 6.5
  })), _circle362 || (_circle362 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 431.4,
    cy: 196.7,
    r: 6.5
  })), _circle363 || (_circle363 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 493,
    cy: 163.6,
    r: 6.5
  })), _circle364 || (_circle364 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 591.7,
    cy: 196.7,
    r: 6.5
  })), _circle365 || (_circle365 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 157.2,
    cy: 205.1,
    r: 6.5
  })), _circle366 || (_circle366 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 478,
    cy: 164.4,
    r: 6.5
  })), _circle367 || (_circle367 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1064.9,
    cy: 166.1,
    r: 6.5
  })), _circle368 || (_circle368 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 984.7,
    cy: 195.2,
    r: 6.5
  })), _circle369 || (_circle369 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 45.4,
    cy: 189.8,
    r: 6.5
  })), _circle370 || (_circle370 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1147.3,
    cy: 162.6,
    r: 6.5
  })), _circle371 || (_circle371 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 98.4,
    cy: 176.6,
    r: 6.5
  })), _circle372 || (_circle372 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 765.4,
    cy: 190.1,
    r: 6.5
  })), _circle373 || (_circle373 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 552.5,
    cy: 162.3,
    r: 6.5
  })), _circle374 || (_circle374 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 770.3,
    cy: 164.5,
    r: 6.5
  })), _circle375 || (_circle375 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 621.1,
    cy: 202.1,
    r: 6.5
  })), _circle376 || (_circle376 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 741.1,
    cy: 158.2,
    r: 6.5
  })), _circle377 || (_circle377 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 557.9,
    cy: 177,
    r: 6.5
  })), _circle378 || (_circle378 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 169.4,
    cy: 181.9,
    r: 6.5
  })), _circle379 || (_circle379 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 373.2,
    cy: 166.3,
    r: 6.5
  })), _circle380 || (_circle380 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 908.2,
    cy: 229.5,
    r: 6.5
  })), _circle381 || (_circle381 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 895.1,
    cy: 175.9,
    r: 6.5
  })), _circle382 || (_circle382 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1127.9,
    cy: 180.4,
    r: 6.5
  })), _circle383 || (_circle383 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 920.5,
    cy: 220.9,
    r: 6.5
  })), _circle384 || (_circle384 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 311.7,
    cy: 188.7,
    r: 6.5
  })), _circle385 || (_circle385 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1017.1,
    cy: 213.1,
    r: 6.5
  })), _circle386 || (_circle386 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 654.5,
    cy: 181.6,
    r: 6.5
  })), _circle387 || (_circle387 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 813.9,
    cy: 133.2,
    r: 6.5
  })), _circle388 || (_circle388 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1239,
    cy: 176,
    r: 6.5
  })), _circle389 || (_circle389 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 155.6,
    cy: 175.2,
    r: 6.5
  })), _circle390 || (_circle390 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 552.7,
    cy: 202.9,
    r: 6.5
  })), _circle391 || (_circle391 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 264.5,
    cy: 184.8,
    r: 6.5
  })), _circle392 || (_circle392 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 580.8,
    cy: 127.7,
    r: 6.5
  })), _circle393 || (_circle393 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 1435.1,
    cy: 180.6,
    r: 6.5
  })), _circle394 || (_circle394 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 843.3,
    cy: 219.1,
    r: 6.5
  })), _circle395 || (_circle395 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 946.7,
    cy: 159.5,
    r: 6.5
  })), _circle396 || (_circle396 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 587.2,
    cy: 182.5,
    r: 6.5
  })), _circle397 || (_circle397 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 432.4,
    cy: 226.6,
    r: 6.5
  })), _circle398 || (_circle398 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 873.2,
    cy: 214.5,
    r: 6.5
  })), _circle399 || (_circle399 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 504.7,
    cy: 217.8,
    r: 6.5
  })), _circle400 || (_circle400 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1088.6,
    cy: 175.1,
    r: 6.5
  })), _circle401 || (_circle401 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 721.5,
    cy: 140.4,
    r: 6.5
  })), _circle402 || (_circle402 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 431.6,
    cy: 211.7,
    r: 6.5
  })), _circle403 || (_circle403 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 335.8,
    cy: 178.7,
    r: 6.5
  })), _circle404 || (_circle404 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 585.8,
    cy: 141.8,
    r: 6.5
  })), _circle405 || (_circle405 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 562.4,
    cy: 191.5,
    r: 6.5
  })), _circle406 || (_circle406 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 576,
    cy: 153.2,
    r: 6.5
  })), _circle407 || (_circle407 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 746.3,
    cy: 213.2,
    r: 6.5
  })), _circle408 || (_circle408 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 471.4,
    cy: 204.5,
    r: 6.5
  })), _circle409 || (_circle409 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 886.9,
    cy: 163.3,
    r: 6.5
  })), _circle410 || (_circle410 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 555.9,
    cy: 136.5,
    r: 6.5
  })), _circle411 || (_circle411 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 341.4,
    cy: 192.6,
    r: 6.5
  })), _circle412 || (_circle412 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 803.5,
    cy: 229.2,
    r: 6.5
  })), _circle413 || (_circle413 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 740.4,
    cy: 118.7,
    r: 6.5
  })), _circle414 || (_circle414 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 221.2,
    cy: 166,
    r: 6.5
  })), _circle415 || (_circle415 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 182.6,
    cy: 189.1,
    r: 6.5
  })), _circle416 || (_circle416 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 117.1,
    cy: 184.8,
    r: 6.5
  })), _circle417 || (_circle417 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 469.9,
    cy: 151.8,
    r: 6.5
  })), _circle418 || (_circle418 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 969.4,
    cy: 169.5,
    r: 6.5
  })), _circle419 || (_circle419 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 910.1,
    cy: 175,
    r: 6.5
  })), _circle420 || (_circle420 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 499.9,
    cy: 149.9,
    r: 6.5
  })), _circle421 || (_circle421 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 760.5,
    cy: 135.5,
    r: 6.5
  })), _circle422 || (_circle422 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 864.9,
    cy: 177.6,
    r: 6.5
  })), _circle423 || (_circle423 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 143.8,
    cy: 198.4,
    r: 6.5
  })), _circle424 || (_circle424 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 855.2,
    cy: 189,
    r: 6.5
  })), _circle425 || (_circle425 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 129.6,
    cy: 176.6,
    r: 6.5
  })), _circle426 || (_circle426 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 240.9,
    cy: 203.3,
    r: 6.5
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st6",
    cx: 697.8,
    cy: 113.2,
    rx: 6.6,
    ry: 6.5
  })), _circle427 || (_circle427 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 422.7,
    cy: 150.3,
    r: 6.5
  })), _circle428 || (_circle428 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 514.2,
    cy: 176.1,
    r: 6.5
  })), _circle429 || (_circle429 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 195.4,
    cy: 181.3,
    r: 6.5
  })), _circle430 || (_circle430 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 348.6,
    cy: 205.8,
    r: 6.5
  })), _circle431 || (_circle431 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 528.6,
    cy: 210.9,
    r: 6.5
  })), _circle432 || (_circle432 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 834.2,
    cy: 190.7,
    r: 6.5
  })), _circle433 || (_circle433 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 630.7,
    cy: 190.6,
    r: 6.5
  })), _circle434 || (_circle434 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 572.4,
    cy: 179.9,
    r: 6.5
  })), _circle435 || (_circle435 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 824.1,
    cy: 162.4,
    r: 6.5
  })), _circle436 || (_circle436 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 548.2,
    cy: 228.6,
    r: 6.5
  })), _circle437 || (_circle437 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1199,
    cy: 173.9,
    r: 6.5
  })), _circle438 || (_circle438 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 880.3,
    cy: 176.7,
    r: 6.5
  })), _circle439 || (_circle439 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 71.1,
    cy: 164.1,
    r: 6.5
  })), _circle440 || (_circle440 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 993.7,
    cy: 207.1,
    r: 6.5
  })), _circle441 || (_circle441 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 384.8,
    cy: 144.3,
    r: 6.5
  })), _circle442 || (_circle442 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 640.8,
    cy: 219.9,
    r: 6.5
  })), _circle443 || (_circle443 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 483.3,
    cy: 124.9,
    r: 6.5
  })), _circle444 || (_circle444 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 883.3,
    cy: 203.4,
    r: 6.5
  })), _circle445 || (_circle445 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 650.9,
    cy: 248.1,
    r: 6.5
  })), _circle446 || (_circle446 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1035.2,
    cy: 168.7,
    r: 6.5
  })), _circle447 || (_circle447 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 775.2,
    cy: 138.4,
    r: 6.5
  })), _circle448 || (_circle448 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 707.4,
    cy: 178.4,
    r: 6.5
  })), _circle449 || (_circle449 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 873.4,
    cy: 190,
    r: 6.5
  })), _circle450 || (_circle450 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 838.8,
    cy: 165.1,
    r: 6.5
  })), _circle451 || (_circle451 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 333.6,
    cy: 205.4,
    r: 6.5
  })), _circle452 || (_circle452 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 610.3,
    cy: 133.2,
    r: 6.5
  })), _circle453 || (_circle453 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 835.7,
    cy: 232.1,
    r: 6.5
  })), _circle454 || (_circle454 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 99.8,
    cy: 191.6,
    r: 6.5
  })), _circle455 || (_circle455 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1007.6,
    cy: 201.4,
    r: 6.5
  })), _circle456 || (_circle456 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 616,
    cy: 187.9,
    r: 6.5
  })), _circle457 || (_circle457 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 858,
    cy: 216.1,
    r: 6.5
  })), _circle458 || (_circle458 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 688.4,
    cy: 201.4,
    r: 6.5
  })), _circle459 || (_circle459 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 708.9,
    cy: 218.8,
    r: 6.5
  })), _circle460 || (_circle460 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1300.3,
    cy: 180.6,
    r: 6.5
  })), _circle461 || (_circle461 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 606.4,
    cy: 199.4,
    r: 6.5
  })), _circle462 || (_circle462 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 626.2,
    cy: 216.3,
    r: 6.5
  })), _circle463 || (_circle463 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 665.7,
    cy: 250.9,
    r: 6.5
  })), _circle464 || (_circle464 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 639.7,
    cy: 138.7,
    r: 6.5
  })), _circle465 || (_circle465 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 843,
    cy: 139.3,
    r: 6.5
  })), _circle466 || (_circle466 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 737.1,
    cy: 239.5,
    r: 6.5
  })), _circle467 || (_circle467 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 543.2,
    cy: 214.5,
    r: 6.5
  })), _circle468 || (_circle468 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1079.6,
    cy: 163.1,
    r: 6.5
  })), _circle469 || (_circle469 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 252.5,
    cy: 193.9,
    r: 6.5
  })), _circle470 || (_circle470 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 330.2,
    cy: 164.7,
    r: 6.5
  })), _circle471 || (_circle471 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 717.6,
    cy: 206.6,
    r: 6.5
  })), _circle472 || (_circle472 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 262.4,
    cy: 170,
    r: 6.5
  })), _circle473 || (_circle473 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 315,
    cy: 162.8,
    r: 6.5
  })), _circle474 || (_circle474 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 760.6,
    cy: 175.9,
    r: 6.5
  })), _circle475 || (_circle475 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 306,
    cy: 174.8,
    r: 6.5
  })), _circle476 || (_circle476 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 411.4,
    cy: 175.7,
    r: 6.5
  })), _circle477 || (_circle477 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1051.9,
    cy: 193.4,
    r: 6.5
  })), _circle478 || (_circle478 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 547.6,
    cy: 188.8,
    r: 6.5
  })), _circle479 || (_circle479 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 484.9,
    cy: 150.9,
    r: 6.5
  })), _circle480 || (_circle480 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 461.4,
    cy: 226,
    r: 6.5
  })), _circle481 || (_circle481 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 784.9,
    cy: 167.5,
    r: 6.5
  })), _circle482 || (_circle482 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 871.9,
    cy: 164.3,
    r: 6.5
  })), _circle483 || (_circle483 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 931.7,
    cy: 160.5,
    r: 6.5
  })), _circle484 || (_circle484 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 557.9,
    cy: 217.2,
    r: 6.5
  })), _circle485 || (_circle485 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 448.2,
    cy: 165.9,
    r: 6.5
  })), _circle486 || (_circle486 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 142.2,
    cy: 168.4,
    r: 6.5
  })), _circle487 || (_circle487 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 208.6,
    cy: 188.5,
    r: 6.5
  })), _circle488 || (_circle488 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 770.8,
    cy: 205.2,
    r: 6.5
  })), _circle489 || (_circle489 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 712.8,
    cy: 128.2,
    r: 6.5
  })), _circle490 || (_circle490 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 793.4,
    cy: 240.4,
    r: 6.5
  })), _circle491 || (_circle491 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 1212,
    cy: 181.4,
    r: 6.5
  })), _circle492 || (_circle492 = /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 300.1,
    cy: 161,
    r: 6.5
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st7",
    transform: "translate(1405.9 199.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Manuel Po, 88")))))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(1405.9 211.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Misamis Oriental")))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 687.7,
    y1: 35.6,
    x2: 687.7,
    y2: 281.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 687.7,
    y1: 283.7,
    x2: 687.7,
    y2: 283.7
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(671.7 18.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Median age")))))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "translate(683.5 26.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "55")))))), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 552.7,
    y1: 211.7,
    x2: 552.7,
    y2: 262.9
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st7",
    transform: "translate(513.6 274.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Paolo Duterte, 49")))))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(513.6 286.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Davao City")))))), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 208.2,
    y1: 127.1,
    x2: 208.2,
    y2: 163
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st7",
    transform: "translate(199 112.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ejay Falcon, 34")))))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(199 124.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Oriental Mindoro")))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st7",
    transform: "translate(1164.6 210.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Gloria Arroyo, 77")))))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(1164.6 222.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pampanga")))))), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 807.1,
    y1: 211.8,
    x2: 807.1,
    y2: 254.6
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st7",
    transform: "translate(789.8 264.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Hilario Davide III, 60")))))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(789.8 276.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cebu")))))), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 14.6,
    y1: 35.6,
    x2: 14.6,
    y2: 41.6
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st7",
    transform: "translate(1132.7 140.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cynthia Villar, 74")))))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(1132.7 152.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Las Pinas")))))), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 529.8,
    y1: 87.5,
    x2: 529.8,
    y2: 138.8
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st7",
    transform: "translate(508.6 70.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Gerville Luistro, 48")))))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(508.6 82.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Batangas")))))), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 7.6,
    y1: 186.9,
    x2: 7.6,
    y2: 222.8
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st7",
    transform: "translate(1.5 233.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "John Gilbert Agojo, 25")))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(1.5 245.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Bulacan")))))), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 914,
    y1: 35.6,
    x2: 914,
    y2: 287.2
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(893.8 20.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Retirement age")))))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "translate(910.4 28.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "65")))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(271 73.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Each circle in this chart ")), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(271 82.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "represents a candidate for a ")), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(271 92.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "legislative district in the ")), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(271 101.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Philippines and their age.")))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(964.8 71.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Age does not figure prominently on an election debate ")), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(964.8 81.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "in the Philippines, and the Constitution only prescribes ")), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(964.8 90.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "a minimum age requirement for some top positions\u2014 ")), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(964.8 100.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "for a member of the House of Representatives, it is ")), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(964.8 110)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "set at 25 years old.")))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(1317.8 71.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "But political scientists and population experts ")), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(1317.8 81.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "believe Filipino voters put some weight in age ")), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(1317.8 90.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "when deciding who to vote for, whether as a ")), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(1317.8 100.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "barometer of experience or to gauge if someone ")), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(1317.8 110)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "is healthy enough to govern.")))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(269.2 245.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "As of January this year, 573 candidates have ")), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(269.2 255)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "filed candidacies for representation of these ")), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(269.2 264.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "districts, 508 of which are in this chart.")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalAge);
export default __webpack_public_path__ + "static/media/total_age.2ce1c1bc4e1ca0f75a0dc36f654170e8.svg";
export { ForwardRef as ReactComponent };